import uniqueId from 'lodash/uniqueId';
import React, { InputHTMLAttributes } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    name: string;
    label: string;
    value: string | string[] | number;
    type?: 'text' | 'email' | 'number' | 'tel' | 'password';
    ref?: React.MutableRefObject<HTMLInputElement | null>;
}

const MaterialInput: React.FunctionComponent<Props> = (props) => {
    const [autoId] = React.useState(uniqueId(props.name));
    const [showPassword, setShowPassword] = React.useState(false);
    const id = props.id || autoId;

    let showPasswordButton = null;
    if (props.type === 'password' && props.value !== '') {
        showPasswordButton = (
            <button type="button" className="password-reveal-button" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? 'verbergen' : 'anzeigen'}
            </button>
        );
    }

    return (
        <div className="form-element form-input">
            <input
                {...props}
                type={props.type === 'password' && showPassword ? 'text' : props.type}
                name={props.name}
                className={'form-element-field ' + (props.type === 'password' ? 'form-element-field--password' : '')}
                placeholder=" "
                value={props.value}
                required={props.required}
                onChange={props.onChange}
                id={id}
            />
            {showPasswordButton}
            <div className="form-element-bar" />
            <label htmlFor={id} className="form-element-label">
                {props.label}
            </label>
        </div>
    );
};

export default MaterialInput;
